import { useLocation } from "react-router-dom";

export const isPreviewSearch = (search) => {
    const s = typeof search === "string" ? search : "";
    return new URLSearchParams(s).get("mode") === "preview";
};

export const useIsPreview = () => {
    const { search } = useLocation();
    return isPreviewSearch(search);
};

export const withPreviewQuery = (path, isPreview) => {
    if (!isPreview) return path;
    return `${path}${path.includes("?") ? "&" : "?"}mode=preview`;
};
